import axios from "axios";
import { silentRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * @function DeleteStamp delete user's stamp
 * @param {Object} payload {instance, account}
 * @returns {string} string of delete status
 */
export const DeleteStamp = (payload) => {
  return payload.instance
    .acquireTokenSilent({ ...silentRequest, account: payload.account })
    .then((tokenResponse) => {
        return axios
        .delete(API_URL + "/stamps/", {
          headers: {
            Authorization: "Bearer " + tokenResponse.accessToken,
          },
        }).then((res) => {
          return res.status;
        }).catch((error) => {
          return error;
        })
    })
    .catch((error) => {
      payload.instance.acquireTokenRedirect(silentRequest);
      return error;
    });
};